import BaseModel from '../../../../base/base_model';
import _ from '../../../../utils/underscore';
import Device from '../../../../utils/device/device';
import {ON_DEMAND} from './on_demand_hybrid_consts';
import Store from '../../../../utils/store';
import {KEY_NAME, ODR_SHARED_GAMES} from "../../native/native_const";



class OnDemandModel extends BaseModel {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'OnDemandModel';

    _nTimeOut = 0;
    _bEnableChillRemoteLoading = false;

    init(params) {

        if (_.isNullOrUndefined(params)) {
            return;
        }

        if(!_.isNullOrUndefined(params.enableChillRemoteLoading)) {
            this._bEnableChillRemoteLoading = params.enableChillRemoteLoading;
        }

        if (Device.hybrid.isHybrid) {
            if (Device.os.isIOS) {
                params = params.ios;
            } else if (Device.os.isAndroid) {
                params = params.android;
            }
        }

        if (!_.isNullOrUndefined(params) && !_.isNullOrUndefined(params.timeout)) {
            this._nTimeOut = params.timeout;
        }
    }

    /**
     * @get the Function Name
     */
    getFuncName(data) {
        let fn = data[ON_DEMAND.CB_FN];

        return undefined !== fn ? fn : '';
    }

    isEnableChillRemoteLoading() {
        return this._bEnableChillRemoteLoading;
    }

    getTimeOut() {
        return this._nTimeOut;
    }


    _gatValToStore(gameType, sharedFolder){

        let val = gameType.toString();

        if(ODR_SHARED_GAMES.RED_TIGER === sharedFolder){
            val = ODR_SHARED_GAMES.RED_TIGER;
        } else if(ODR_SHARED_GAMES.PRAGMATIC_PLAY === sharedFolder){
            val = ODR_SHARED_GAMES.PRAGMATIC_PLAY;
        } else if(ODR_SHARED_GAMES.PLAY_N_GO === sharedFolder){
            val = ODR_SHARED_GAMES.PLAY_N_GO;
        }else if(ODR_SHARED_GAMES.BLUEPRINT === sharedFolder){
            val = ODR_SHARED_GAMES.BLUEPRINT;
        }

        return val + ',';
    }
    saveOnDemandLoadedGame(gameType, sharedFolder) {

        const val = this._gatValToStore(gameType, sharedFolder);

        let allvals = Store.get(ON_DEMAND.ODR_GAMES,'');

        if(!allvals.includes(val)) {
            allvals+=val;
            Store.set(ON_DEMAND.ODR_GAMES,allvals);
        }
    }

    getAllOnDemandGames(){
        return Store.get(ON_DEMAND.ODR_GAMES,'');
    }

    resetAllOnDemandGames(){
        Store.set(ON_DEMAND.ODR_GAMES,'');
    }

    isOnDemandLoadedGame(gameType) {
        return true;
    }

    deleteGameFolders(data){
        let games = _.safeJSONandDecode(data);

        if(_.isEmpty(games.data)){
            return;
        }

        const gameArr = games.data[KEY_NAME.ODR_DEL_GAMES].split(',');

        if(_.isEmpty(gameArr)){
            return;
        }

        let allGames = this.getAllOnDemandGames();

        for (let i=0; i < gameArr.length; i++) {
            if(gameArr[i].length > 0) {
                allGames = allGames.replace(gameArr[i] + ',','');
            }
        }

        Store.set(ON_DEMAND.ODR_GAMES,allGames);

        return allGames;
    }
}

export default OnDemandModel;